export default "__VITE_ASSET__C8VnzpA7__"